import React from "react";
import "./Publications.css";

interface Publication {
  title: string;
  link: string;
  description: string;
}

const publications: Publication[] = [
  {
    title: "Generative-CNN for Pattern Recognition in Finance - ICAIF 2024",
    link: "https://dl.acm.org/doi/10.1145/3677052.3698622",
    description:
      "Leveraging GAN to synthesize candlestick images for stocks and fine tune CNN model to predict stock movement visually.",
  },
  {
    title: "Performant LLM Agentic Framework for Conversational AI - IEEE 2025",
    link: "https://arxiv.org/abs/2503.06410",
    description:
      "The rise of Agentic applications and automation in the Voice AI industry has led to an increased reliance on Large Language Models (LLMs) to navigate graph-based logic workflows composed of nodes and edges. However, existing methods face challenges such as alignment errors in complex workflows and hallucinations caused by excessive context size. To address these limitations, we introduce the Performant Agentic Framework (PAF), a novel system that assists LLMs in selecting appropriate nodes and executing actions in order when traversing complex graphs. PAF combines LLM-based reasoning with a mathematically grounded vector scoring mechanism, achieving both higher accuracy and reduced latency. Our approach dynamically balances strict adherence to predefined paths with flexible node jumps to handle various user inputs efficiently. Experiments demonstrate that PAF significantly outperforms baseline methods, paving the way for scalable, real-time Conversational AI systems in complex business environments."
  }
];

const Publications: React.FC = () => {
  return (
    <div className="publications-container">
      <h1 className="publications-heading text-glow">Publications</h1>

      {/* If you add more, each publication can be listed here */}
      <div className="publications-grid">
        {publications.map((pub, index) => (
          <div key={index} className="publication-card">
            <h2 className="publication-title">{pub.title}</h2>
            <p className="publication-description">{pub.description}</p>
            <a
              className="publication-link"
              href={pub.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Read Publication
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Publications;
